//
// Use javascript to insert arrow icon
//

$.fn.linkArrow = function (classes) {
    $(this).each(function(){
        var $link = $(this),
            arrowIcon = $link.find('.fa-chevron-double-right');
        
        if (!arrowIcon.length) {
            $('<i>')
                .addClass('fas fa-chevron-double-right ' + classes)
                .attr('aria-hidden', 'true')
                .appendTo($link);
        }
    });
};